































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IAddress } from '@/services/addresses/models'

@Component({
    components: {},
})
export default class AddressDataTable extends Vue {
    @Prop() addresses!: IAddress[]
    @Prop() links?: boolean
    @Prop() title?: string

    get headers(): any[] {
        return [
            { text: 'Address', value: 'address' },
            { text: 'AVAX Balance', value: 'avaxBalance' },
        ]
    }
}
